import { get } from "lodash";
import { useSelector } from "react-redux";
import { selectPersonalDetail } from "redux/modules/personalSlice";

export default function usePersonalDetail() {
  const personalDetail = useSelector(selectPersonalDetail);
  const personalId = get(personalDetail, "personalID", "");

  return {
    personalDetail,
    personalId,
  };
}
